module.exports = __webpack_public_path__ + "images/cbc4e764f960d7233b62cb7fedb84aff.svg";